import React from 'react';
import { withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { Segment, Grid, Message, Icon } from 'semantic-ui-react';

import Field from '@/components/Field';
import { FormProps } from '@/components/Form';

type Props = FormProps & LocalizeContextProps;

const WebhookSetttingsForm: React.FC<Props> = (props) => {
    const { translate } = props;

    return (
        <Segment attached="top">
            <Grid>
                <Grid.Column computer={8} mobile={16}>
                    <Field
                        name="Enabled"
                        type="checkbox"
                        toggle
                        slider
                        label={translate('webhookSettings.enabled')}
                    />
                </Grid.Column>
            </Grid>
            <Message
                icon="info"
                info
            >
                <Icon name='info' />
                <Message.Content>
                    {translate('webhookSettings.info')}
                </Message.Content>
            </Message>
        </Segment>
    );
};

export default withLocalize(WebhookSetttingsForm);
